module.exports = __webpack_public_path__ + "img/leftbicep.6e337f90.svg";